import { createContext } from 'preact';
export const CompanyContext = createContext(null);
